import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import UniversityService from '../../../services/KangarooServices/UniversityService';
import DestinationService from '../../../services/KangarooServices/DestinationService';
import ChannelService from '../../../services/KangarooServices/Intelligence/ChannelService';
import { Container, Row, Col, Input, Pagination, PaginationItem, PaginationLink, Button, Card, CardBody } from 'reactstrap';
import { imageBaseApi } from '../../../utilis/imageHelper';
import toast from 'react-hot-toast';
import BreadCrumb from '../../../Components/Common/BreadCrumb';

const Unassignedpartner = () => {
  const navigate = useNavigate();
  
  const [instituteData, setInstituteData] = useState([]); // Changed from allInstitutes to match AssignInstitute
  const [destination, setDestination] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 24;

  
  const [selectedInstitutes, setSelectedInstitutes] = useState([]);
  const [orderIndex, setOrderIndex] = useState(0);

  const fetchInstitutes = async (destinationId = "") => {
    setLoading(true);
    try {
      const response = await UniversityService.getList(destinationId);
      setInstituteData(response || []);
      setCurrentPage(1);
    } catch (error) {
      console.log(error);
      toast.error("Failed to fetch institutes");
    } finally {
      setLoading(false);
    }
  };

  const fetchDestinations = async () => {
    try {
      const response = await DestinationService.getList();
      setDestination(response || []);
    } catch (error) {
      console.log(error);
      toast.error("Failed to fetch destinations");
    }
  };

  useEffect(() => {
    fetchInstitutes();
    fetchDestinations();
  }, []);

  useEffect(() => {
    fetchInstitutes(selectedCountry);
  }, [selectedCountry]);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  // Serch filtering
  const filteredInstitutes = instituteData.filter((inst) => {
    const term = searchTerm.toLowerCase();
    return (
      inst.name?.toLowerCase().includes(term) ||
      inst.destination?.name?.toLowerCase().includes(term)
    );
  });

  const totalPages = Math.ceil(filteredInstitutes.length / itemsPerPage);

  const paginatedInstitutes = filteredInstitutes.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage,
  );

  // Toggle institute selection
  const toggleSelectInstitute = (institute) => {
    setSelectedInstitutes((prev) =>
      prev.some((i) => i.id === institute.id)
        ? prev.filter((i) => i.id !== institute.id)
        : [...prev, institute],
    );
  };

  
  const isSelected = (institute) =>
    selectedInstitutes.some((i) => i.id === institute.id);

  // Remove institute from selection
  const removeInstitute = (instituteId) => {
    setSelectedInstitutes((prev) => prev.filter((i) => i.id !== instituteId));
  };

  
  const handleAssignSubmit = async () => {
    if (!selectedInstitutes.length) {
      toast.error("Please select at least one institute");
      return;
    }

    const payload = {
      channelPartnerId: null,
      orderIndex: parseInt(orderIndex) || 0,
      universityIds: selectedInstitutes.map((i) => i.id),
    };

    try {
      await ChannelService.createAssignUni(payload);
      toast.success(`${selectedInstitutes.length} institutes assigned successfully!`);
      navigate("/channel-partners");
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to assign institutes");
      console.log(error);
    }
  };

  return (
    <div className='page-content'>
      <Container fluid>
        <BreadCrumb
          title="Assign Institutes"
          pageTitle="Channel Partner"
          breadcrumbItems={[
            { title: "Back to List", link: "/channel-partners" },
          ]}
        />

        {/* Search, Filter and Action Row */}
        <Row className="mb-3">
          <div className="d-flex justify-content-between">
            <div className="d-flex gap-2">
              <Col lg={8}>
                <select
                  className="form-select"
                  value={selectedCountry}
                  onChange={(e) => setSelectedCountry(e.target.value)}
                >
                  <option value="">All Destinations</option>
                  {destination.map((d) => (
                    <option key={d.id} value={d.id}>
                      {d.name}
                    </option>
                  ))}
                </select>
              </Col>

              <Col lg={8}>
                <Input
                  placeholder="Search institute"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </Col>

              <Col lg={4}>
                <Input
                  type="number"
                  placeholder="Order Index"
                  value={orderIndex}
                  onChange={(e) => setOrderIndex(e.target.value)}
                  min="0"
                />
              </Col>
            </div>
            
            <div>
              <Col lg={12}>
                {selectedInstitutes.length > 0 && (
                  <Button color="success" onClick={handleAssignSubmit}>
                    Assign Institutes ({selectedInstitutes.length})
                  </Button>
                )}
              </Col>
            </div>
          </div>
        </Row>

        {/* Selected Institutes Badges */}
        {selectedInstitutes.length > 0 && (
          <Row className="mb-3">
            <Col>
              <div className="p-2 bg-light rounded d-flex flex-wrap align-items-center">
                <strong className="me-2">Selected Institutes:</strong>
                {selectedInstitutes.map((inst) => (
                  <span
                    key={inst.id}
                    className="badge bg-primary me-1 mb-1 d-flex align-items-center"
                    style={{ fontSize: "0.85rem" }}
                  >
                    {inst.name}
                    <span
                      className="ms-1"
                      style={{ fontWeight: "bold", cursor: "pointer" }}
                      onClick={(e) => {
                        e.stopPropagation();
                        removeInstitute(inst.id);
                      }}
                    >
                      ×
                    </span>
                  </span>
                ))}
              </div>
            </Col>
          </Row>
        )}

        {/* Institutes Grid */}
        <Row className="g-2 mt-3">
          {loading ? (
            <Col className="text-center">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </Col>
          ) : paginatedInstitutes.length > 0 ? (
            paginatedInstitutes.map((institute, index) => (
              <Col xl={2} lg={3} md={4} sm={6} key={institute.id || index}>
                <Card
                  onClick={() => toggleSelectInstitute(institute)}
                  className={`h-100 text-center p-2 ${
                    isSelected(institute) ? "border border-primary border-3" : "border"
                  }`}
                  style={{ cursor: "pointer", borderRadius: "10px" }}
                >
                  <CardBody>
                    <img
                      src={`${imageBaseApi}${institute.logoMedia?.url}`}
                      alt={institute.name}
                      style={{ objectFit: "contain" }}
                      className="mb-2 img-fluid"
                    />
                    <h6 className="text-truncate mb-0" style={{ fontSize: "13px" }}>
                      {institute.name}
                    </h6>
                  </CardBody>
                </Card>
              </Col>
            ))
          ) : (
            <Col className="text-center py-5">
              <p className="text-muted">No institutes found</p>
            </Col>
          )}
        </Row>

        {/* Pagination */}
        {totalPages > 1 && (
          <Row className="mt-4">
            <Col className="d-flex justify-content-center">
              <Pagination>
                <PaginationItem disabled={currentPage === 1}>
                  <PaginationLink
                    previous
                    onClick={() => setCurrentPage(currentPage - 1)}
                  />
                </PaginationItem>

                {[...Array(totalPages)].map((_, index) => (
                  <PaginationItem
                    key={index}
                    active={currentPage === index + 1}
                  >
                    <PaginationLink onClick={() => setCurrentPage(index + 1)}>
                      {index + 1}
                    </PaginationLink>
                  </PaginationItem>
                ))}

                <PaginationItem disabled={currentPage === totalPages}>
                  <PaginationLink
                    next
                    onClick={() => setCurrentPage(currentPage + 1)}
                  />
                </PaginationItem>
              </Pagination>
            </Col>
          </Row>
        )}
      </Container>
    </div>
  );
};

export default Unassignedpartner;